import { render, staticRenderFns } from "./loan-detail.vue?vue&type=template&id=3437319c&"
import script from "./loan-detail.vue?vue&type=script&lang=ts&"
export * from "./loan-detail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports